function Kuwait({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1475)">
        <path d="M31.0048 21.5651C31.6479 19.8318 32 17.9571 32 16C32 14.0428 31.6479 12.1681 31.0048 10.4348L16 9.04346L0.995188 10.4348C0.352063 12.1681 0 14.0428 0 16C0 17.9571 0.352063 19.8318 0.995188 21.5651L16 22.9565L31.0048 21.5651Z" fill="#F0F0F0"/>
        <path d="M16 32.0002C22.8794 32.0002 28.7441 27.6582 31.0047 21.5654H0.995117C3.25587 27.6582 9.12049 32.0002 16 32.0002Z" fill="#D80027"/>
        <path d="M16 0C9.12049 0 3.25587 4.342 0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 16 0Z" fill="#6DA544"/>
        <path d="M4.68628 4.68604C-1.56209 10.9344 -1.56209 21.0651 4.68628 27.3135C6.31721 25.6826 7.90909 24.0907 10.4348 21.565V10.4346L4.68628 4.68604Z" fill="black"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Kuwait;
